import MixedChart from './mixedChart.component';

export default MixedChart;